import React, { useState } from "react";
import classes from "./MembershipValidationPhone.module.css";
import { FieldPhone } from "components/form/FieldPhone";
import Button from "components/Button";
import { useMutation } from "@apollo/client";
import { savePhoneMutation } from "../../mutations";
import NotificationPopover from "components/NotificationPopover/NotificationPopover";
import {
  getErrorsAndSuccess,
  extractServerErrorMessage
} from "utils/extractErrors";
import cn from "classnames";
import { SpinnerBack } from "components/Spinner/Spinner";

const extractPhoneSaveSuccess = getErrorsAndSuccess("phone_save");
const extractErrorMessage = extractServerErrorMessage("phone_save");

export const MembershipValidationPhone = (props) => {
  const {
    isPhoneEdit,
    onChangePhone,
    setIsPhoneEdit,
    phoneNumber,
    onClose
  } = props;
  const [error, setError] = useState("");

  const [savePhoneAction, { loading: savePhoneLoading }] = useMutation(savePhoneMutation, {
    fetchPolicy: "no-cache",
    onCompleted: (response) => {
      if(extractPhoneSaveSuccess.isSuccess({ data: response })) {
        setIsPhoneEdit(false);
      } else {
        const errorText = extractErrorMessage({ data: response });
        setError(errorText);
      }
    }
  });

  return (
    <div className={classes.container}>
      {savePhoneLoading && <SpinnerBack />}
      <div className={classes.content}>
        <FieldPhone
          disabled={!isPhoneEdit}
          autoComplete="off"
          className={cn('mt-16 mb-16', classes.fieldPhone, !isPhoneEdit && classes.isPhoneEdit)}
          id="membership-phone"
          label="Phone number"
          name="phone_number"
          errors={{}}
          value={phoneNumber}
          onChange={e => {
            onChangePhone(e.target.value);
            setError('');
          }}
        />

        {!isPhoneEdit ? (
          <Button
            ghost
            label="Edit phone number"
            onClick={() => setIsPhoneEdit(true)}
            className={cn('underline', classes.editButton)}
          />
        ) : null}
      </div>

      {isPhoneEdit ? (
        <footer className="mt-16 mt-m-20">
          <Button
            secondary
            label="Cancel"
            onClick={() => onClose(false)}
            className="mr-16 mr-l-24 mr-xxl-32"
          />

          <Button
            disabled={!(phoneNumber?.match(/\d/g)?.length >= 11)}
            label="Send me a code"
            onClick={() => savePhoneAction(({
              variables: {
                phone_number: phoneNumber
              }
            }))}
          />
        </footer>
      ) : null}

      {error?.length !== 0 && (
        <NotificationPopover
          show={true}
          status="error"
          text={error}
          onClose={() => {
            setError('');
          }}
        />
      )}
    </div>
  );
};
